import React, { CSSProperties } from "react"
import {IconDefinition} from "@fortawesome/fontawesome-common-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from './ActionIcon.scss'

export interface ActionIconProps {
  onClick?:(event: React.MouseEvent<HTMLDivElement>) => void
  className?: string,
  selected?: boolean,
  icon: IconDefinition,
  iconHover: IconDefinition,
  children?: React.ReactNode,
  style?:CSSProperties,
  'data-cy'?: string
}

const ActionIcon = ({'data-cy': dataCY, className, icon, iconHover, children, selected= false, onClick, style}: ActionIconProps) => {
  return (
    <div data-cy={dataCY} className={`${styles.action_icon} ${ selected ? styles.selected : ''} ${className ? className:''}`} onClick={onClick} style={style}>
      {children}
      <FontAwesomeIcon style={{ width: '20px', height: '20px' }} icon={
        selected ? iconHover : icon
      } />
    </div>
  )
}

export default ActionIcon
